import React from 'react';
import styled from 'styled-components';

import Form from 'components/ui/Form';
import SingleFileUpload from 'components/ui/SingleFileUpload/SingleFileUpload';
import Row from 'components/ui/Row';
import Col from 'components/ui/Col';
import Spacer from 'components/ui/Spacer';

import { getTranslatedString } from 'helpers/i18n';
import { eventPhotoAcceptedFileTypes } from 'helpers/FileHelper';

const StyledTitle = styled.span`
  font-size: 18px;
  font-family: 'Circular-Bold';
`;

const PhotoInput = ({ values, errors, touched, setFieldValue, setFieldTouched }) => {
  const handleChange = photo => {
    setFieldValue('photo', photo);
    setFieldTouched('photo', true);
  };

  return (
    <Spacer mb={1}>
      <Row gutter={16}>
        <Col span={24}>
          <StyledTitle>{getTranslatedString('landlordPortal.events.attachPhoto')}</StyledTitle>
        </Col>
        <Col span={24}>
          <Form.Item
            validateStatus={touched.photo && errors.photo ? 'error' : null}
            help={touched.photo && errors.photo}
          >
            <SingleFileUpload
              file={values.photo}
              name="photo"
              onChange={handleChange}
              onDropVerbiage={getTranslatedString('landlordPortal.events.photos.dropFileHere')}
              dropFileVerbiage={getTranslatedString('landlordPortal.events.photos.dragAndDrop')}
              browseVerbiage={getTranslatedString('landlordPortal.events.photos.orBrowse')}
              rejectFileError={getTranslatedString('landlordPortal.events.photos.cannotAcceptFile')}
              acceptedFiles={eventPhotoAcceptedFileTypes}
            />
          </Form.Item>
        </Col>
      </Row>
    </Spacer>
  );
};

export default PhotoInput;
